import { type DeviceTypeRecord } from "@/shared/domain/deviceTypes";

/**
 * The choice value meaning "no type". It cannot match a real type, whose `dt_`
 * ID is never empty.
 */
export const NO_DEVICE_TYPE = "";

/** The choices for a device's type: None first, then the org's types sorted by name. */
export function deviceTypeChoices(
  deviceTypes: readonly DeviceTypeRecord[] | undefined,
): { value: string; label: string }[] {
  return [
    { value: NO_DEVICE_TYPE, label: "None" },
    ...[...(deviceTypes ?? [])]
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((deviceType) => ({
        value: deviceType.device_type_id,
        label: deviceType.name,
      })),
  ];
}
